
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation(["hero"]);

  return (
    <div className="relative pt-16 min-h-screen flex items-center justify-center overflow-hidden bg-background">
      <div className="container-custom relative z-10">
        <div className="text-center max-w-4xl mx-auto animate-fade-up">
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-semibold tracking-tight mb-4 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange leading-[2.6] pb-4">
            Skillengers.io
            <span className="block mt-4 text-3xl sm:text-4xl md:text-5xl text-brand-orange">
              {t("title")}
            </span>
          </h1>
          <h2 className="text-xl sm:text-2xl text-muted-foreground mt-12 mb-8 max-w-3xl mx-auto font-medium">
            {t("subtitle")}
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground mb-12 max-w-3xl mx-auto">
            {t("description")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact?type=contact" 
              className="inline-flex items-center px-6 py-3 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {t("contact")}
            </a>
            <a 
              href="/contact?type=demo" 
              className="inline-flex items-center px-6 py-3 rounded-lg border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {t("demo")}
            </a>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/8),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/4),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/5),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/3),transparent)]" />
      </div>
    </div>
  );
};

export default Hero;
